import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { Children } from "../../../../components/miscellianous/children"
import { BSVariantCardWithSizeDto } from "../../../dto/beem-shot/BSVariant/BSProjectCardWithSizeDto"
import { BSVariant } from "../../../dto/beem-shot/BSVariant/BSVariant"
import { useBSVariant } from "../../../hooks/beem-shot/useBSVariant"
import { ProjectContext } from "../../project/ProjectContext"

export const BSVariantListContext = React.createContext<BSVariantListStore>({} as BSVariantListStore)

export function BSVariantListContextProvider({ children }: Readonly<Children>): React.JSX.Element {
  const { getBSVariantListByProject } = useBSVariant()

  const { project } = useContext(ProjectContext)

  const [bsVariants, setBSVariants] = useState<BSVariant[]>([])
  const [isLoaded, setIsLoaded] = useState<boolean>(false)

  const refreshAllBSVariants: (_projectId: string | undefined) => Promise<any> = useCallback(
    (_projectId) => {
      if (_projectId) {
        return getBSVariantListByProject(_projectId)
          .then((variants) => {
            if (variants) {
              setBSVariants(variants)
            }
            return variants
          })
          .then(() => {
            setIsLoaded(true)
          })
      } else {
        setBSVariants([])
        return Promise.resolve()
      }
    },
    [getBSVariantListByProject]
  )

  useEffect(() => {
    refreshAllBSVariants(project?.id)
  }, [refreshAllBSVariants, project?.id])

  const bsVariantStore = useMemo(
    () => ({
      bsVariants,
      fetchAllBSVariants: refreshAllBSVariants,
      setBSVariants,
      isLoaded,
    }),
    [bsVariants, refreshAllBSVariants, isLoaded]
  )

  return <BSVariantListContext.Provider value={bsVariantStore}>{children}</BSVariantListContext.Provider>
}

export type BSVariantListStore = {
  bsVariants: BSVariant[]
  setBSVariants: React.Dispatch<React.SetStateAction<BSVariant[]>>
  fetchAllBSVariants(projectId: string | undefined): Promise<BSVariantCardWithSizeDto>
  isLoaded: boolean
}
